<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="4">
            <h1 class="header margin-top-xl">
              <chevron
                @click="$router.push({name: 'RuleList'})"/>
              {{ $t('rule.title') }}
            </h1>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" class="margin-top-xxl">
          <grid-col col-size="2">
            <div class="center-horizontal">
              <!-- Single Rule  -->
                <safe-router-link to="/rule" class="nav__menu-item">
                  <div v-has-feature="'Rule'" class="personal-area-element">
                    <font-awesome-icon
                      :icon="icons.singleRuleIcon"
                      class="personal-area-element-icon"/>
                    <div class="personal-area-element-title">{{ $t('rule.singleRule') }}</div>
                  </div>
                </safe-router-link>

              <!-- Groupal Rule  -->
              <safe-router-link to="/groupal-rule" class="nav__menu-item">
                <div v-has-feature="'Rule'" class="personal-area-element">
                  <font-awesome-icon
                    :icon="icons.groupalRuleIcon"
                    class="personal-area-element-icon"/>
                  <div class="personal-area-element-title">{{ $t('rule.groupalRule') }}</div>
                </div>
              </safe-router-link>
            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import SafeRouterLink from '../../components/shared/SafeRouterLink';
import {
  faDiceOne,
  faDiceFive
} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

export default {
  name: 'RuleMenu',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron,
    SafeRouterLink,
    FontAwesomeIcon
  },
  data () {
    return {
      icons: {
        singleRuleIcon: faDiceOne,
        groupalRuleIcon: faDiceFive
      },
      breadcrumb: [
        {link: '/workspace', nameKey: 'menu.workspace'},
        {link: '/rule/list', nameKey: 'rule.title'},
        {link: '/rule/title', nameKey: 'rule.newRule', disabled: true}
      ]
    };
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .center-horizontal {
    display: table;
    margin: 0 auto;
  }

  .personal-area-element {
    align-items: center;
    display: inline-block;
    text-align: center;
    background-color: $black-light9;
    border: solid 0.2rem $black-light9;
    border-radius: $radius;
    height: 15rem;
    width: 15rem;
    color: $secondary;
    margin: 1rem;
    padding-top: 2.7rem;
  }

  .personal-area-element:hover {
    border: solid 0.2rem $black-light5;
  }

  .personal-area-element-icon {
    font-size: 7rem;
  }

  .personal-area-element-title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .disabled, .disabled:hover{
    color: $secondary-trans7;
    border: solid 0.2rem $black-light9;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/rules/RuleMenu.vue